import _typeof from "@babel/runtime/helpers/typeof";
import Handlebars from '@sparta.global.vendors/handlebars';

/* eslint-disable no-param-reassign */

/**
 * @method Handlebars.helpers.orderCSS
 * @description takes array of page CSS, sorts it to desired load order, and returns <link /> tags
 * @param {Array} css array of page CSS paths
 * @param {String} assetPath string defining environment-specific path to assets
 * @returns {String} Handlebars.SafeString
 */
function orderCSS(css, assetPath) {
  // initialize empty array for our sorted link tags
  var links = [];

  // define our basic load order sections:
  // vendor utilities, style utility, global utilities, utilities, global modules, modules
  var loadOrder = ['utilities/vendor/', 'utilities/global/sparta-style-utility', 'utilities/global/', 'utilities/', 'modules/global/', 'modules/'];
  css
  // sort our css array
  .sort(function (a, b) {
    // initialize empty indexes for comparison
    var aIndex = 0;
    var bIndex = 0;

    // iterate through our loadOrder definitions to find the first match for our a element
    loadOrder.some(function (item, index) {
      // when a match is found, save the index
      if (a.indexOf(item) > -1) {
        aIndex = index;

        // exit the Array.prototype.some
        return true;
      }

      // continue iterating
      return false;
    });

    // iterate through our loadOrder definitions to find the first match for our b element
    loadOrder.some(function (item, index) {
      // when a match is found, save the index
      if (b.indexOf(item) > -1) {
        bIndex = index;

        // exit the Array.prototype.some
        return true;
      }

      // continue iterating
      return false;
    });

    // sort by desired order index
    return aIndex - bIndex;
  })

  // iterate through sorted css array
  .forEach(function (link) {
    // get actual href for link tag
    var href = Handlebars.helpers.pathClean(assetPath, link);

    // add link tag to links array
    links.push("<link rel=\"stylesheet\" type=\"text/css\" href=\"".concat(href, "\">"));
  });

  // return formatted link tags as string
  return new Handlebars.SafeString(links.join('\n\t'));
}

/**
 * Cleans given path strings
 *
 * @param {String} str1 first given string, some number of '/' characters
 * @param {String} str2 path to clean of '/'
 * @returns {String} the cleaned path
 */
function pathClean(str1, str2) {
  return str2.charAt(0) === '/' && str1 === '/' ? str2 : "".concat(str1.replace(/\/+$/, ''), "/").concat(str2);
}

/**
 * Origin CDN
 * @param {string} env - siteParams.env
 * @returns {*|string|string} constructed origin path
 * @description Nucleus assets can't resolve uat CDN, VTIM team uses this helper
 * to resolve the origin cdn.
 */
function originCDN(env) {
  var prods = ['prod1_h_w', 'prod2_h_2'];
  var environments = ['dev1_h_w', 'dev2_h_w', 'dev3_h_w', 'dev4_h_w', 'devflex1_h_w', 'sit1a_h_w', 'sit2a_h_w', 'sit3_h_w', 'sitbc_h_w', 'pssit_h_w', 'preview1_h_w', 'preview2_h_w', 'pt1_h_w', 'pt2_h_w', 'review1_h_w', 'review2_h_w'];
  if (env === 'local') return 'http://localhost:4005';
  if (prods.includes(env) || env.includes('prod')) return 'https://origin-bac-assets.bankofamerica.com';
  if (environments.includes(env)) return "https://origin-bac-assets-".concat(env.replace('_h_w', ''), "-helix.ecnp.bankofamerica.com");
  return 'https://origin-bac-assets.bankofamerica.com';
}

/**
 * Function to construct url for fetching nucleus development script off of the cdn based
 * on given environment.
 *
 * @param {String} env environment to fetch script for
 * @returns {String} the constructed url
 */
function nucleusDevelopment(env) {
  var prods = ['prod1_h_w', 'prod2_h_2'];
  var environments = ['dev1_h_w', 'dev2_h_w', 'dev3_h_w', 'dev4_h_w', 'devflex1_h_w', 'sit1a_h_w', 'sit2a_h_w', 'sit3_h_w', 'sitbc_h_w', 'pssit_h_w', 'preview1_h_w', 'preview2_h_w', 'pt1_h_w', 'pt2_h_w', 'review1_h_w', 'review2_h_w'];
  var nucleusScript = '/nucleus/spa-assets/components/utilities/global/nucleus/1.0.0/js/index.js';
  var nucleusDevelopment = '/nucleus/spa-assets/components/utilities/global/nucleus-development/1.1.0/js/index.js';
  if (env === 'local') return "http://localhost:4005".concat(nucleusDevelopment);
  if (prods.includes(env) || env.includes('prod')) return "https://origin-bac-assets.bankofamerica.com".concat(nucleusScript);
  if (environments.includes(env)) return "https://origin-bac-assets-".concat(env.replace('_h_w', ''), "-helix.ecnp.bankofamerica.com").concat(nucleusDevelopment);
  return "https://origin-bac-assets.bankofamerica.com".concat(nucleusScript);
}

/**
 * Checks a given Object of attributes for the presence of required attributes
 *
 * @param {Object} attrs Object of attributes and their values
 * @param {Array} requiredAttrs Array of required attributes
 * @returns {Object} Object containing a boolean pass value and optional string missingField
 */
function requiredAttrsCheck(attrs, requiredAttrs) {
  var attr;
  for (var i = 0, len = requiredAttrs.length; i < len; i++) {
    attr = requiredAttrs[i];
    if (attrs[attr] === undefined) {
      return {
        pass: false,
        missingField: attr
      };
    }
  }
  return {
    pass: true
  };
}

/**
 * Combines attribute values for attributes specified in combinableAttrs
 *
 * @param {Object} attrs Object of attributes and their values
 * @param {Object} combinableAttrs List of combinable attributes
 * @returns {void}
 */
function combineAttrs(attrs, combinableAttrs) {
  var attrVal;
  Object.keys(combinableAttrs).forEach(function (attrName) {
    attrVal = combinableAttrs[attrName];
    if (attrs[attrName] && attrName === 'value') {
      attrs[attrName] += attrVal;
    } else if (attrs[attrName] && attrName) {
      attrs[attrName] += " ".concat(attrVal);
    } else {
      attrs[attrName] = attrVal;
    }
  });
}

/**
 * Removes reserved attributes from a given object of attributes
 *
 * @param {Object} attrs Object of attributes and values
 * @param {Array} reservedAttrs Array of reserved attribute names
 * @returns {void}
 */
function removeReservedAttrs(attrs, reservedAttrs) {
  for (var i = 0, len = reservedAttrs.length; i < len; i++) {
    delete attrs[reservedAttrs[i]];
  }
}

/**
 * Takes an object of attributes and values, and creates a string from each
 *
 * @param {Object} attrs Object of attributes and their values
 * @returns {String} the constructed string of attribute values
 */
function buildAttrsString(attrs) {
  var str = '';
  var attrVal;
  Object.keys(attrs).forEach(function (attrName) {
    attrVal = attrs[attrName];
    str += " ".concat(attrName, "=").concat(_typeof(attrVal) === 'object' ? "'".concat(JSON.stringify(attrVal), "'") : "\"".concat(attrVal, "\""));
  });
  return str;
}

/**
 * Extend - extend an object
 * @param {object} opts - options
 * @param {object} target - Target object to extend.
 * @param {object} source - Source object you are extending with.
 * @returns {object} the extended object
 */
function extend() {
  var opts;
  var target;
  var source;
  if (arguments.length < 3) {
    target = (arguments.length <= 0 ? undefined : arguments[0]) || {};
    source = (arguments.length <= 1 ? undefined : arguments[1]) || {};
    opts = {
      extendArray: false
    };
  } else {
    opts = (arguments.length <= 0 ? undefined : arguments[0]) || {};
    target = (arguments.length <= 1 ? undefined : arguments[1]) || {};
    source = (arguments.length <= 2 ? undefined : arguments[2]) || {};
  }
  Object.keys(source).forEach(function (prop) {
    // if this property is an object
    if (_typeof(source[prop]) === 'object') {
      // if we aren't supposed to extend arrays and this is an array
      if (!opts.extendArray && Array.isArray(source[prop])) {
        // replace the original array property with the new array property
        target[prop] = source[prop];
        // if we are supposed to extend arrays or this isn't an array
      } else {
        // recursively call this extend method to extend the object as needed
        target[prop] = Handlebars.helpers.extend(target[prop], source[prop]);
      }
      // if this isn't an object
    } else {
      // replace the property
      target[prop] = source[prop];
    }
  });

  // return the extended object
  return target;
}
export { buildAttrsString, combineAttrs, extend, nucleusDevelopment, orderCSS, originCDN, pathClean, removeReservedAttrs, requiredAttrsCheck };